module.exports = __webpack_public_path__ + "static/media/zameen-quadrangle.08d1971c.jpg";